import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetDataSourceTemplatesDocument,
  type GetDataSourceTemplatesQuery,
  type GetDataSourceTemplatesQueryVariables,
} from "~/features/dataSourceTemplates/gqls";
import { useTenant } from "~/features/tenant/context";

/**
 * Loads the full data-source-template list for the current tenant. V1 parity:
 * the query is tenant-scoped via `tenantId` and the whole list is fetched at
 * once, then filtered / paginated client-side.
 */
export function useDataSourceTemplatesList() {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  return useSuspenseQuery<GetDataSourceTemplatesQuery, GetDataSourceTemplatesQueryVariables>(
    GetDataSourceTemplatesDocument,
    { variables: { tenantId }, fetchPolicy: "cache-and-network" },
  );
}
